// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-summary_documents',
    // #endregion
    // #region Properties
    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        process: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        elements: [],
        isLoading: false,
    }),
    computed: {
        processId() {
            return this.process.processID;
        },
    },
    // #endregion
    // #region Constructor
    async beforeMount() {
        this.load();
    },
    // #endregion
    // #region Methods
    methods: {
        async load() {
            this.isLoading = true;
            //Create 
            let tData = await this.$host.api.get('/forms/processes/' + this.processId, { params: { mode: 'merged_uploads' } });
            if (tData.data) {
                this.elements = tData?.data?.elements ?? {};
            }
            this.isLoading = false;
        },
    },
    //#endregion
});
// #endregion
